import { getCurrentUser } from '@/store/reducers/UserStore';
import {
  getSenderNameFromMessage,
  isMessageFromAsta,
} from '@/utils/variantBasedLabels';
import { IconAi2Logo } from '@/components/icons/IconAi2Logo';
import { Message } from '@/models/Message';
import { useAppSelector } from '@/store/hooks';

import { Avatar, styled } from '@mui/material';
import classnames from 'classnames';

export interface UserIconProps {
  message: Message;
  isAsta?: boolean;
}

export const UserIcon = ({
  message,
  isAsta: isAstaOverride,
}: UserIconProps) => {
  const currentUser = useAppSelector(getCurrentUser);
  const isAsta = isAstaOverride || isMessageFromAsta(message);
  const isViewer = message.sender.uuid === currentUser?.uuid;
  const nameLabel = getSenderNameFromMessage(message, isAsta);

  const icon = (() => {
    if (isAsta) {
      return <Ai2Icon height="20" width="20" />;
    }
    if (isViewer) {
      return 'U';
    }
    return message.sender.displayName?.[0]?.toUpperCase() || '👤';
  })();

  return (
    <ChatIcon
      variant="rounded"
      className={classnames({
        'message_icon--is-viewer': isViewer,
        'message_icon--is-asta': isAsta,
      })}
      title={nameLabel}
    >
      {icon}
    </ChatIcon>
  );
};

const ChatIcon = styled(Avatar)`
  background-color: #9c27b0;
  color: #faf2e9;
  font-size: 18px;
  font-weight: 600;
  line-height: 24px;
  height: 30px;
  width: 30px;

  &.message_icon--is-viewer {
    background-color: #9c27b0;
  }

  &.message_icon--is-asta {
    background-color: ${({ theme }) => theme.palette.primary.main};
  }
`;

const Ai2Icon = styled(IconAi2Logo)`
  fill: ${({ theme }) => theme.palette.text.primary};
`;
